/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Guest } from '../../models/guest';
import { UpdateGuestDto } from '../../models/update-guest-dto';

export interface GuestsControllerUpdate$Params {
  id: string;
      body: UpdateGuestDto
}

export function guestsControllerUpdate(http: HttpClient, rootUrl: string, params: GuestsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Guest>> {
  const rb = new RequestBuilder(rootUrl, guestsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Guest>;
    })
  );
}

guestsControllerUpdate.PATH = '/admin/guests/{id}';
